/* eslint-disable */
import Api from '@/services/Api'

export default {
    create(data){
        try {
            return Api().post('user/', data);
        }catch(err){
            console.log(err);
            return err
        }
    },
    update(data){
        try {
            return Api().put('user/', data);
        }catch(err){
            console.log(err);
            return err
        }
    },
    deleteRecord(data){
        try {
            return Api().delete('user/', {data});
        }catch(err){
            console.log(err);
            return err
        }
    },
    getAll(){
        try {
            return Api().get('student/');
        }catch(err){
            console.log(err);
            return err
        }
    },
    getAllUserRoles(){
        try{
            return Api().get('user/role/all');
        }catch(err){
            console.log(err);
            return err
        }
    },
    getAllUserStatus(){
        try{
            return Api().get('user/status/all');
        }catch(err){
            console.log(err);
            return err
        }
    },
}
